/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseVideoTutorial } from '../models/api-response-video-tutorial';
import { getVideoTutorialByLang } from '../fn/video-tutorial-client-api/get-video-tutorial-by-lang';
import { GetVideoTutorialByLang$Params } from '../fn/video-tutorial-client-api/get-video-tutorial-by-lang';

@Injectable({ providedIn: 'root' })
export class VideoTutorialClientApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getVideoTutorialByLang()` */
  static readonly GetVideoTutorialByLangPath = '/v1/api/video-tutorial-client/{lang}/{name}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVideoTutorialByLang()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVideoTutorialByLang$Response(params: GetVideoTutorialByLang$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVideoTutorial>> {
    return getVideoTutorialByLang(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVideoTutorialByLang$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVideoTutorialByLang(params: GetVideoTutorialByLang$Params, context?: HttpContext): Observable<ApiResponseVideoTutorial> {
    return this.getVideoTutorialByLang$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVideoTutorial>): ApiResponseVideoTutorial => r.body)
    );
  }

}
